"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeIScriptWithRedeemer = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
var CanBeData_1 = require("../utils/CanBeData.js");
function normalizeIScriptWithRedeemer(script) {
    var redeemer = (0, CanBeData_1.forceData)(script.redeemer);
    return (0, cardano_ledger_ts_1.isIUTxO)(script.ref) ? {
        ref: new cardano_ledger_ts_1.UTxO(script.ref),
        redeemer: redeemer
    } : {
        inline: script.inline.clone(),
        redeemer: redeemer
    };
}
exports.normalizeIScriptWithRedeemer = normalizeIScriptWithRedeemer;
